<div [class]="{ negative: indicator().color === 'red', positive: indicator().color === 'green' }">
  <mat-icon [matTooltip]="indicator().title">{{ indicator().icon }}</mat-icon>
</div>